<template>
  <div style="min-height:100%;background:#FAFAFA;">
    <div
      style="padding:.08rem .1rem .28rem;width:100%;box-sizing: border-box;min-height:100%;"
    >
      <div class="topCon">
        <div class="toJt" @click="toJt">
          <span
            style="box-shadow:0px .02rem .06rem 0px rgba(0,0,0,0.08);border-radius:.16rem;font-size:.13rem;color:#199EF4;padding:.07rem .12rem;border:.01rem solid rgba(25,158,244,1);"
            >切换简图 ›</span
          >
        </div>
        <div class="inToOut">
          <div style="text-align:center;">
            <div class="stationDir">上高速口</div>
            <div class="stationName">
              {{ ruStationObj ? ruStationObj.name : "" }}
            </div>
          </div>
          <div class="goto">
            <img
              src="../../assets/img/gotoCrow.png"
              alt=""
              style="width:.24rem;height:.24rem;"
            />
          </div>
          <div style="text-align:center;">
            <div class="stationDir">下高速口</div>
            <div class="stationName">
              {{ chuStationObj ? chuStationObj.name : "" }}
            </div>
          </div>
        </div>
        <div class="goCross">
          {{ formObj.totalMiles }}公里|途径：{{ formObj.roadline }}
        </div>
        <!-- <cube-tab-bar v-model="selectIndex" :show-slider='true' @click="clickHandler" style="margin:10px 0;" ref="tabNav">
          <cube-tab label='1' value='1'>
            <span>交通拥堵</span>
            <span style="color:#199EF4;margin-left:3px;">{{formObj.slow}}</span>
          </cube-tab>
          <cube-tab label='2' value='2'>
            <span>交通事故</span>
            <span style="color:#199EF4;margin-left:3px;">{{formObj.event}}</span>
          </cube-tab>
          <cube-tab label='3' value='3'>
            <span>管制信息</span>
            <span style="color:#199EF4;margin-left:3px;">{{formObj.control}}</span>
          </cube-tab>
          <cube-tab label='4' value='4'>
            <span>道路施工</span>
            <span style="color:#199EF4;margin-left:3px;">{{formObj.construction}}</span>
          </cube-tab>
        </cube-tab-bar> -->
        <div class="wt-tab">
          <div class="tab">
            <ul class="full">
              <li
                v-for="(item, index) in navList"
                :key="index"
                @click="clickHandler(item, index)"
                :class="{ active: selectIndex == index }"
              >
                <span>{{ item.text }}</span>
                <span
                  style="color:#199EF4;margin-left:.03rem;font-weight: bolder;"
                  >{{ item.num }}</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mainCon" v-show="mianConList.length">
        <ul>
          <li
            v-for="(item, index) in mianConList"
            :key="index"
            style="margin-bottom:.1rem;"
          >
            <div class="times">{{ item.occtimeRaw }}</div>
            <div
              style="background:rgba(250,250,250,1);border-radius:.06rem;margin-top:.1rem;padding:.1rem;"
            >
              <div class="concreteCon">
                <div class="titles">
                  <img
                    src="../../assets/img/img01_active.png"
                    alt=""
                    style="width:.22rem;height:.22rem;"
                    v-show="item.eventtype == 1006301"
                  />
                  <img
                    src="../../assets/img/img02_active.png"
                    alt=""
                    style="width:.22rem;height:.22rem;"
                    v-show="item.eventtype == 1006302"
                  />
                  <img
                    src="../../assets/img/img03_active.png"
                    alt=""
                    style="width:.22rem;height:.22rem;"
                    v-show="item.eventtype == 1006303"
                  />
                  <img
                    src="../../assets/img/img04_active.png"
                    alt=""
                    style="width:.22rem;height:.22rem;"
                    v-show="item.eventtype == 1006002"
                  />
                  <img
                    src="../../assets/img/img05_active.png"
                    alt=""
                    style="width:.22rem;height:.22rem;"
                    v-show="item.eventtype == 1006003"
                  />
                  <div
                    style="display: flex;justify-content: space-between;width:100%;margin-left:.09rem;"
                  >
                    <div>
                      <div>
                        <span
                          style="font-size:.14rem;font-weight:600;line-height:.2rem;"
                          class="sjNameText"
                          v-show="item.eventtype == 1006301"
                          >交通事故</span
                        >
                        <span
                          style="font-size:.14rem;font-weight:600;line-height:.2rem;"
                          class="sjNameText"
                          v-show="item.eventtype == 1006302"
                          >交通拥堵</span
                        >
                        <span
                          style="font-size:.14rem;font-weight:600;line-height:.2rem;"
                          class="sjNameText"
                          v-show="item.eventtype == 1006303"
                          >管制信息-{{ item.controlArea }}</span
                        >
                        <span
                          style="font-size:.14rem;font-weight:600;line-height:.2rem;"
                          class="sjNameText"
                          v-show="item.eventtype == 1006002"
                          >正在施工</span
                        >
                        <span
                          style="font-size:.14rem;font-weight:600;line-height:.2rem;"
                          class="sjNameText"
                          v-show="item.eventtype == 1006003"
                          >施工计划</span
                        >
                      </div>
                      <div style="font-size:.12rem;line-height:.17rem;">
                        {{ item.directionname }}
                      </div>
                    </div>
                    <div class="roadName">{{ item.shortname }}</div>
                  </div>
                </div>
              </div>
              <div class="conText">
                {{ item.reportout }}
              </div>
              <div class="statusDetial">
                <div>
                  道路情况：<span
                    v-show="item.status == 1008002"
                    style="color:#FF9845"
                    >缓行</span
                  ><span v-show="item.status == 1008003" style="color:#CF1322"
                    >拥堵</span
                  ><span v-show="item.status == 1008001" style="color:#17C295"
                    >畅通</span
                  ><span style="color:#FAAD14" v-show="item.status == 1008004"
                    >阻断</span
                  ><span style="color:#FF4D4F" v-show="item.status == 1008005"
                    >施工</span
                  >
                </div>
                <div class="toMore" @click="toMore(item)">更多></div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="dontHave" v-show="!mianConList.length">
        <img
          src="../../assets/img/haveNo.png"
          alt=""
          style="width:1.1rem;height:1.1rem;"
        />
        <div style="color:#999999;font-size:.14rem;margin-top:.19rem;">
          暂无记录
        </div>
      </div>
      <!-- 详情弹出层 -->
    </div>
    <div v-if="detialFlag" class="stationDetialSty">
      <cube-scroll
        ref="scroll2"
        class="scroll-list-inner-wrap"
        :options="{ observeDOM: false, bounce: false }"
      >
        <div class="cube-extend-popup-content" style="">
          <slot>
            <div class="stationCon">
              <div style="height:.1rem;"></div>
              <div class="titleCon">
                <div style="width:.22rem;height:.22rem;margin-top:.09rem;">
                  <img
                    src="../../assets/img/img01_active.png"
                    alt=""
                    v-show="detialForm.eventtype == 1006301"
                  />
                  <img
                    src="../../assets/img/img02_active.png"
                    alt=""
                    v-show="detialForm.eventtype == 1006302"
                  />
                  <img
                    src="../../assets/img/img03_active.png"
                    alt=""
                    v-show="detialForm.eventtype == 1006303"
                  />
                  <img
                    src="../../assets/img/img04_active.png"
                    alt=""
                    v-show="detialForm.eventtype == 1006002"
                  />
                  <img
                    src="../../assets/img/img05_active.png"
                    alt=""
                    v-show="detialForm.eventtype == 1006003"
                  />
                </div>
                <div class="sjName">
                  <div>
                    <span
                      class="sjNameText"
                      v-show="detialForm.eventtype == 1006301"
                      >交通事故</span
                    >
                    <span
                      class="sjNameText"
                      v-show="detialForm.eventtype == 1006302"
                      >交通拥堵</span
                    >
                    <span
                      class="sjNameText"
                      v-show="detialForm.eventtype == 1006303"
                      >管制信息</span
                    >
                    <span
                      class="sjNameText"
                      v-show="detialForm.eventtype == 1006002"
                      >正在施工</span
                    >
                    <span
                      class="sjNameText"
                      v-show="detialForm.eventtype == 1006003"
                      >施工计划</span
                    >
                  </div>
                  <!-- <div class="address">
                    {{detialForm.shortname}}
                    {{detialForm.directionname}}
                  </div> -->
                  <div style="font-size:.12rem;color:#787878">
                    {{ detialForm.directionname }}
                  </div>
                  <div style="font-size:.12rem;color:#787878">
                    {{ detialForm.occtimeRaw }}
                  </div>
                </div>
                <div class="ypbb" @click="vioceClick(detialForm.reportout)">
                  音频播报<img
                    src="../../assets/img/yinbo.png"
                    alt=""
                    style="width:.12rem;height:.1067rem;vertical-align: middle;"
                  />
                </div>
              </div>
              <div class="statusCon">
                <div>
                  道路情况：<span
                    v-show="detialForm.status == 1008002"
                    style="color:#FF9845"
                    >缓行</span
                  ><span
                    v-show="detialForm.status == 1008003"
                    style="color:#CF1322"
                    >拥堵</span
                  ><span
                    v-show="detialForm.status == 1008001"
                    style="color:#17C295"
                    >畅通</span
                  ><span
                    style="color:#FAAD14"
                    v-show="detialForm.status == 1008004"
                    >阻断</span
                  ><span
                    style="color:#FF4D4F"
                    v-show="detialForm.status == 1008005"
                    >施工</span
                  >
                </div>
                <div>拥堵距离：{{ detialForm.distance }}千米</div>
                <div v-show="detialForm.eventtype == 1006303">
                  管制范围：{{ detialForm.controlArea }}
                </div>
                <div v-show="detialForm.eventtype == 1006303">
                  管制措施：{{ detialForm.controltypename }}
                </div>
              </div>
              <div class="grayBlock"></div>
              <div class="mainCon">
                <div class="titles">路况详情</div>
                <div class="conText">
                  {{ detialForm.reportout }}
                </div>
              </div>
              <div class="steps" v-if="detialForm.log && detialForm.log.length">
                <div class="titles">事情进展</div>
                <ul>
                  <li v-for="(item, index) in detialForm.log" :key="index">
                    <div class="stepIcon">
                      <img
                        src="../../assets/img/stepIcon.png"
                        alt=""
                        style="width:100%;"
                      />
                    </div>
                    <div class="times">
                      <div>{{ item.created }}</div>
                    </div>
                    <div class="stepCon">
                      <div class="logstatusCon">
                        <div>
                          <div>
                            <span>道路情况：</span>
                            <span
                              style="color:#17C295"
                              v-show="item.roadtrafficcolor == 1008001"
                              >畅通</span
                            >
                            <span
                              style="color:#FF7A45"
                              v-show="item.roadtrafficcolor == 1008002"
                              >缓慢</span
                            >
                            <span
                              style="color:#CF1322"
                              v-show="item.roadtrafficcolor == 1008003"
                              >拥堵</span
                            >
                            <span
                              style="color:#FAAD14"
                              v-show="item.roadtrafficcolor == 1008004"
                              >阻断</span
                            >
                            <span
                              style="color:#FF4D4F"
                              v-show="item.roadtrafficcolor == 1008005"
                              >施工</span
                            >
                          </div>
                          <div v-show="item.roadtrafficcolor != 1008001">
                            <span>拥堵距离：</span>
                            <span>{{ item.distance }}千米</span>
                          </div>
                        </div>
                        <div v-show="detialForm.eventtype == 1006303">
                          <div>
                            <span>管制方式：</span>
                            <span>{{ item.controltypename }}</span>
                          </div>
                        </div>
                        <div
                          v-show="
                            detialForm.eventtype == 1006303 &&
                              (item.involvedarea == 1006502 ||
                                item.involvedarea == 1006503)
                          "
                        >
                          <div>
                            <span>受影响站：</span>
                            <span>{{ item.influenceStation }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="height:.2rem"></div>
                  </li>
                </ul>
              </div>
              <div style="height:.1rem"></div>
            </div>
          </slot>
        </div>
      </cube-scroll>
    </div>
    <div
      v-if="detialFlag"
      style="height:100%;width:100%;background-color: #25262d;opacity: .4;z-index:14;position: fixed;bottom: 0;"
      @click.stop.prevent="closeDetial"
    ></div>
    <div id="bdtts_div_id"></div>
  </div>
</template>

<script>
import eventBus from "../../utils/eventBus.js";

export default {
  data() {
    return {
      browser: this.$route.params.browser,
      navList: [],
      selectIndex: 0,
      detialFlag: false,
      ruStationObj: {},
      chuStationObj: {},
      formObj: {},
      mianConList: [],
      ydList: [],
      sgList: [],
      gzList: [],
      dlList: [],
      detialForm: {},
      vioceFlag: true,
      ttsAudio: ""
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.ruStationObj = JSON.parse(sessionStorage.getItem("ruStationObj"));
    this.chuStationObj = JSON.parse(sessionStorage.getItem("chuStationObj"));
    // if (window.history && window.history.pushState) {
    //   // 往历史记录里面添加一条新的当前页面的url
    //   history.pushState(null, null, document.URL);
    //   // 给 popstate 绑定一个方法 监听页面刷新
    //   window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
    // }

    // this.$refs.tabNav.setSliderTransform(32);
  },
  beforeDestroy() {
    eventBus.$off("formObj");
    if (this.detialFlag) {
      this.cancel();
      this.ttsAudio.pause();
      this.detialFlag = false;
    }
  },

  destroyed() {
    // window.removeEventListener("popstate", this.backChange, false);
  },

  methods: {
    backChange() {
      if (this.detialFlag) {
        this.cancel();
        this.ttsAudio.pause();
        this.detialFlag = false;
      } else {
        this.$router.push(`/fastChoose`);
      }
    },
    toJt() {
      this.$router.push(
        `/planRoad?instationcode=${this.$route.query.instationcode}&outstationcode=${this.$route.query.outstationcode}`
      );
    },
    getData() {
      eventBus.$on("formObj", val => {
        this.formObj = val;
        this.navList = [
          {
            text: "交通拥堵",
            num: this.formObj.slow
          },
          {
            text: "交通事故",
            num: this.formObj.event
          },
          {
            text: "管制信息",
            num: this.formObj.control
          },
          {
            text: "道路施工",
            num: this.formObj.construction
          }
        ];
        this.ydList = this.formObj.slowArray;
        this.sgList = this.formObj.eventArray;
        this.gzList = this.formObj.controlArray;
        this.dlList = this.formObj.constructionArray;
        this.mianConList = this.ydList;
      });
    },
    clickHandler(obj, ind) {
      this.selectIndex = ind;
      if (ind == 0) {
        this.mianConList = this.ydList;
      } else if (ind == 1) {
        this.mianConList = this.sgList;
      } else if (ind == 2) {
        this.mianConList = this.gzList;
      } else if (ind == 3) {
        this.mianConList = this.dlList;
      }
    },
    toMore(obj) {
      this.detialForm = obj;
      this.detialFlag = true;
      this.$nextTick(() => {
        let offsetHeight = document.querySelector(".cube-scroll-content")
          .offsetHeight;
        document.querySelector(".cube-scroll-wrapper").style.height =
          offsetHeight > 472 ? 472 + "px" : offsetHeight + "px";
      });
    },
    closeDetial() {
      this.detialFlag = false;
      this.ttsAudio.pause();
      this.cancel();
    },
    // 语音
    // vioceClick(con) {
    //   var ttsAudio = document.getElementById("tts_autio_id");
    //   //   this.vioceLoading = true;
    //   // let loadingToast = this.$createToast({
    //   //   txt: "正在加载中...",
    //   //   mask: true
    //   // }).show();

    //   if (this.vioceFlag) {
    //     var ttsDiv = document.getElementById("bdtts_div_id");
    //     // 文字转语音
    //     var au1 = '<audio id="tts_autio_id" autoplay="autoplay">';
    //     var sss =
    //       '<source id="tts_source_id" src="http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&per=3&spd=5&ctp=1&text=' +con +'" type="audio/mpeg">';
    //     var eee = '<embed id="tts_embed_id" height="0" width="0" src="">';
    //     var au2 = "</audio>";
    //     ttsDiv.innerHTML = au1 + sss + eee + au2;
    //     ttsAudio = document.getElementById("tts_autio_id");
    //     ttsAudio.play();
    //     setTimeout(() => {
    //       // loadingToast.hide();
    //     }, 2500);
    //   } else {
    //     ttsAudio.pause();
    //     // loadingToast.hide();
    //   }
    //   this.vioceFlag = this.vioceFlag ? false : true;
    // },
    // 语音
    vioceClick(con) {
      if (this.browser.versions.ios) {
        window.synthesizeStop();
        if (this.vioceFlag) {
          // let to_speak = new SpeechSynthesisUtterance(con);
          // window.speechSynthesis.speak(to_speak);
          // 改成调iossdk
          window.synthesizeText(con);
          this.vioceFlag = false;
        } else {
          this.vioceFlag = true;
        }
      } else if (this.browser.versions.android) {
        var ttsAudio = document.getElementById("tts_autio_id");
        //   this.vioceLoading = true;
        // let loadingToast = this.$createToast({
        //   txt: "正在加载中...",
        //   mask: true
        // }).show();

        if (this.vioceFlag) {
          var ttsDiv = document.getElementById("bdtts_div_id");
          // 文字转语音
          var au1 = '<audio id="tts_autio_id" autoplay="autoplay">';
          var sss =
            '<source id="tts_source_id" src="http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&per=3&spd=5&ctp=1&text=' +
            con +
            '" type="audio/mpeg">';
          var eee = '<embed id="tts_embed_id" height="0" width="0" src="">';
          var au2 = "</audio>";
          ttsDiv.innerHTML = au1 + sss + eee + au2;
          this.ttsAudio = document.getElementById("tts_autio_id");
          this.ttsAudio.play();
          setTimeout(() => {
            // loadingToast.hide();
          }, 2500);
        } else {
          this.ttsAudio.pause();
          // loadingToast.hide();
        }
        this.vioceFlag = this.vioceFlag ? false : true;
      }
    },
    cancel() {
      window.speechSynthesis.cancel();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
/deep/ .cube-tab-bar-slider {
  background-color: #199ef4;
  width: 0.16rem !important;
}
/deep/ .cube-tab-bar {
  padding: 0.1rem 0;
  font-size: 0.12rem;
  color: #787878;
}
/deep/ .cube-tab_active {
  color: #787878;
}
.wt-tab {
  width: 100%;
  .tab {
    background: #fff;
    padding: 0.1rem 0;
    //  margin-top: 10px;
    ul {
      display: flex;
      font-size: 0.12rem;
      &.default {
        justify-content: space-around;
      }
      &.full {
        justify-content: space-between;
        li {
          flex: 1;
          text-align: center;
        }
      }
      li {
        height: 0.17rem;
        line-height: 0.17rem;
        padding: 0.1rem 0;
        &.active {
          color: #1bb5f1;
        }
        &.active::after {
          height: 0.02rem;
          content: "";
          background-color: #1bb5f1;
          display: block;
          margin-top: 0.1rem;
          width: 30%;
          margin-left: 40%;
          border-radius: 0.02rem;
        }
      }
    }
  }
}

.topCon {
  padding: 0 0.1rem 0.1rem 0.1rem;
  background-color: #fff;
  border-radius: 0.06rem;
  .toJt {
    padding: 0.15rem 0px;
    text-align: right;
    margin-bottom: 0.15rem;
  }
  .inToOut {
    display: flex;
    justify-content: space-between;
    font-size: 0.15rem;
    .stationDir {
      color: #787878;
    }
    .stationName {
      font-weight: 600;
      line-height: 0.21rem;
      color: rgba(61, 61, 61, 1);
      margin-top: 4px;
    }
  }
  .goCross {
    color: #787878;
    font-size: 0.12rem;
    margin-top: 0.19rem;
  }
}
.mainCon {
  background-color: #fff;
  margin-top: 0.1rem;
  padding: 0.1rem;
  border-radius: 0.06rem;
  .times {
    font-size: 0.12rem;
    color: rgba(120, 120, 120, 1);
    line-height: 0.17rem;
  }
  .concreteCon {
    .titles {
      display: flex;
      align-items: center;
      .roadName {
        font-size: 0.12rem;
        color: rgba(61, 61, 61, 1);
        line-height: 0.17rem;
        height: 0.17rem;
        background: rgba(238, 236, 236, 1);
        padding: 0.01rem 0.06rem;
      }
    }
  }
  .conText {
    font-size: 0.12rem;
    color: rgba(120, 120, 120, 1);
    line-height: 0.18rem;
    padding: 0.1rem 0.23rem 0.1rem 0;
    border-bottom: 0.01rem solid #eeeeee;
  }
  .statusDetial {
    display: flex;
    justify-content: space-between;
    padding: 0.15rem 0 0.05rem 0;
    font-size: 0.12rem;
    .toMore {
      color: #199ef4;
    }
  }
}
.dontHave {
  text-align: center;
  padding-top: 0.43rem;
}
.stationDetialSty {
  /deep/ .cube-scroll-wrapper {
    max-height: 4.72rem;
    position: fixed;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    z-index: 16;
    padding: 0.1rem;
    background: #fff;
    // height: 100%;
    .stationCon {
      .titleCon {
        display: flex;
        padding-bottom: 0.08rem;
        .sjName {
          font-size: 0.14rem;
          line-height: 0.2rem;
          margin-left: 0.07rem;
          width: 68%;
          > div:first-child {
            span {
              font-weight: bolder;
            }
          }
        }
        .ypbb {
          float: right;
          font-size: 0.12rem;
          color: rgba(61, 61, 61, 1);
          line-height: 0.17rem;
        }
      }
      .statusCon {
        display: flex;
        flex-wrap: wrap;
        font-size: 0.12rem;
        padding: 0.12rem 0;
        border-top: 0.01rem solid #f6f6f6;
        line-height: 0.17rem;
        > div {
          width: 50%;
        }
      }
      .grayBlock {
        width: 100%;
        height: 0.08rem;
        background: #fafafa;
      }
      .mainCon {
        padding: 0.14rem 0;
        margin: 0;
        .titles {
          font-size: 0.14rem;
          font-weight: bolder;
        }
        .conText {
          border: none;
          padding: 0.1rem 0;
        }
      }
    }
    .steps {
      .titles {
        font-size: 0.14rem;
        font-weight: bolder;
      }

      ul {
        padding: 0.12rem;
        font-size: 0.12rem;
        li {
          position: relative;
          border-left: 0.01rem dashed #bae1fb;
          padding: 0 0.14rem;
          .stepIcon {
            left: 0;
            top: 0;
            width: 0.14rem;
            height: 0.14rem;
            position: absolute;
            transform: translateX(-50%);
          }
          .times {
            color: #787878;
            display: flex;
            align-items: center;
          }
          .stepCon {
            // border-radius: 0.1rem;
            margin-top: 0.08rem;
            .titles {
              display: flex;
              align-items: center;
            }
            .statusCon {
              padding: 0.2rem 0;
              border: none;
              display: flex;
              justify-content: space-between;
            }
            .logstatusCon {
              > div {
                display: flex;
                line-height: 2;
                > div {
                  width: 49%;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/roadDetialList/index.vue